import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

const StripePaymentForm = ({ payLabel, onSubmittingChange }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [submitting, setSubmitting] = useState(false);
    const [payError, setPayError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;
        setSubmitting(true);
        if (onSubmittingChange) onSubmittingChange(true);
        setPayError(null);
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: { return_url: `${window.location.origin}/upgrade/success` },
        });
        // Only reached on failure — success navigates away.
        if (error) setPayError(error.message || 'Payment failed. Please try again.');
        setSubmitting(false);
        if (onSubmittingChange) onSubmittingChange(false);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <PaymentElement />
            {payError && <div className="text-red-400 text-sm">{payError}</div>}
            <button
                type="submit"
                disabled={!stripe || submitting}
                className="w-full bg-cyan-500 hover:bg-cyan-400 text-black font-semibold py-3 rounded-lg disabled:opacity-50 transition-all"
            >
                {submitting ? 'Processing…' : payLabel}
            </button>
            <p className="text-[11px] text-neutral-500 text-center">Payments are processed securely by Stripe. Cancel anytime from your profile.</p>
        </form>
    );
};

export default StripePaymentForm;
